import React from 'react'
import { TextField, Box, Paper, Typography, Button } from '@material-ui/core'
import { useForm, useController } from 'react-hook-form'
import { exportDonations } from 'api/communities'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { useDispatch } from 'react-redux'
import { setNotification } from 'actions/status'

// TODO: Might make sense to extract this out at some point. Only used here for now
function Date({ control, name, label, ...passThroughProps }) {
  const { field, fieldState: { error, invalid } } = useController({
    name: name,
    defaultValue: '',
    control,
    rules: { required: { value: true, message: 'Required' } }
  })

  return (
    <TextField
      { ...field }
      label={label}
      type='date'
      required
      helperText={error?.message || '*Required'}
      error={invalid}
      InputLabelProps={{ shrink: true }}
      { ...passThroughProps }
    />
  )
}

// TODO: switch over to MUI date range picker when MUI v5 comes out
// TODO: Add more client-side validations in future e.g. no future date, from can't be > to
export default function DonationDataExport() {
  const dispatch = useDispatch()
  const communityId = useCurrentUserProp('community')
  const { handleSubmit, control, formState: { isValid, isSubmitted } } = useForm()


  function submit({ from, to }) {
    exportDonations({ communityId, from, to }).then((result) => {
      dispatch(setNotification('success', 'Check email for CSV file', { duration: null }))
    }).catch((e) => {
      dispatch(setNotification('error', 'There was a problem exporting the data', { duration: null }))
    })
  }

  return (
    <Box p={3} component={Paper}>
      <Typography paragraph variant='h5'>Export</Typography>
      <form>
        <Date margin='normal' fullWidth name='from' label='From' control={control} />
        <Date margin='normal' fullWidth name='to' label='To' control={control} />
        <Button disabled={!isValid && isSubmitted} onClick={handleSubmit(submit)} size='large' fullWidth color='primary' variant='contained'>
          export
        </Button>
      </form>
    </Box>
  )
}
